export const PUBLICATION_CHANGED_EVENT = "publication:changed";
export const HIDDEN_PUBLICATIONS_STATE_KEY =
  "vivanomada:hidden-publications-state";

const HIDDEN_PUBLICATION_KINDS = new Set([
  "publication-deleted",
  "publication-hidden",
  "publication-reported",
]);

const readHiddenPublicationsState = () => {
  try {
    return JSON.parse(localStorage.getItem(HIDDEN_PUBLICATIONS_STATE_KEY)) || {};
  } catch (error) {
    console.error("Error reading hidden publications state", error);
    return {};
  }
};

export const getPublicationHiddenState = (publicationId) => {
  if (!publicationId || typeof window === "undefined") return false;

  const hiddenState = readHiddenPublicationsState();
  return hiddenState[String(publicationId)] === true;
};

export const getPublicationIdFromPayload = (payload) => {
  if (!payload) return null;

  if (typeof payload === "string" || typeof payload === "number") {
    return payload;
  }

  if (Array.isArray(payload)) {
    for (const item of payload) {
      const publicationId = getPublicationIdFromPayload(item);
      if (publicationId) return publicationId;
    }
    return null;
  }

  if (typeof payload === "object") {
    return (
      payload.idPublicacion ??
      payload.IdPublicacion ??
      payload.idPublication ??
      payload.publicationId ??
      payload.postId ??
      payload.idPost ??
      payload.IdPost ??
      payload.id ??
      payload.Id ??
      payload.publication?.idPublication ??
      payload.publication?.idPublicacion ??
      payload.data?.idPublicacion ??
      payload.data?.idPublication ??
      payload.data?.publicationId ??
      null
    );
  }

  return null;
};

export const dispatchPublicationChanged = ({
  kind,
  publicationId,
  senderId,
  payload,
}) => {
  const resolvedPublicationId =
    publicationId ?? getPublicationIdFromPayload(payload);

  if (!resolvedPublicationId) {
    return false;
  }

  if (HIDDEN_PUBLICATION_KINDS.has(kind)) {
    try {
      const hiddenState = readHiddenPublicationsState();
      hiddenState[String(resolvedPublicationId)] = true;
      localStorage.setItem(
        HIDDEN_PUBLICATIONS_STATE_KEY,
        JSON.stringify(hiddenState),
      );
    } catch (error) {
      console.error("Error saving hidden publication state", error);
    }
  }

  window.dispatchEvent(
    new CustomEvent(PUBLICATION_CHANGED_EVENT, {
      detail: {
        kind,
        publicationId: resolvedPublicationId,
        senderId,
        payload,
      },
    }),
  );

  return true;
};
